<template>
    <!-- <div style="background: #f9f9f9" :style="{ height: parkHeight }"> -->
    <div style="background: #f9f9f9" :style="{ height: parkHeight }">
        <div class="tittle flex">
            <div class="titleTop">
                <div class="logo">
                    <img
                        src="../../assets/images/logoAll.png"
                        alt=""
                    />
                </div>
                <!-- <div class="login flex"> -->
                <div class="login">
                    <div class="lh90" @click="getRegisteredLogin(1)">首页</div>
                    <!-- <div class="lh90" @click="getRegisteredLogin(2)">帮助中心</div> -->
                </div>
            </div>
        </div>
        
        <div style="height: 116px"></div>
        <div class="registered">
            <div class="registeredTop flex">
                <h3>忘记密码</h3>
                <p>
                    <span class="blue" @click="getLogin">登录 > </span>
                </p>
            </div>
            <div class="registered_input_box">
                <div class="registered_input">
                    <div class="passAg">
                        <el-input
                            placeholder="输入手机号码"
                            v-model="mobile"
                            clearable
                            @blur="getinputIphone"
                        >
                        </el-input>
                        <p class="red">{{ iphoneRepeatMess }}</p>
                    </div>
                    <div class="passAg">
                        <el-input
                            placeholder="请设置您的密码"
                            show-password
                            v-model="inputPassword" @keyup.native="cryptographic">
                        </el-input>
                        <p class="red">{{cryptographicMessage}}</p>
                    </div>
                    <div class="passAg" style="margin-bottom: 20px">
                        <el-input
                            placeholder="再次输入密码"
                            show-password
                            v-model="inputPasswordAg"
                            @change="passwordAgChange">
                        </el-input>
                        <p v-if="passwordAgTrue" class="red">您输入的密码与第一次不符</p>
                    </div>
                    
                    <div
                        class="registered_validation flex"
                        @click="getValidation"
                        v-show="vcodes == false">
                        <img src="../../assets/images/validation.png" alt=""/>
                        <p>点击按钮开始安全验证</p>
                        <Vcode
                            :show="validation"
                            @success="onValidation('yes')"
                            @fall="onValidation('no')"
                            @close="onClose"
                            :imgs="imgUrls"
                        />
                    </div>
                    <div class="registered_validation2 flex" v-show="vcodes == true">
                        <i class="el-icon-check"></i>
                        <p>验证成功</p>
                    </div>
                    
                    <div class="registered_input_message">
                        <el-input
                            placeholder="短信验证码"
                            v-model="inputMessage"
                        ></el-input>
                        <p
                            class="registered_input_messageP blue"
                            @click="getCountdown"
                            v-if="canClick">
                            获取验证码
                        </p>
                        <p class="registered_input_messageP" v-else style="color: #b5b5b5">
                            {{ timeClock }}s
                        </p>
                    </div>
                    <!--<div class="registered_agree">-->
                        <!--<el-checkbox v-model="checked" class="blue">-->
                            <!--我已阅读并同意-->
                            <!--<span class="red" @click="getAgreement">《隐私协议》</span>-->
                        <!--</el-checkbox>-->
                    <!--</div>-->
                    <div class="registered_button" @click="getRegisteredMess">
                        <el-button type="primary">修改密码</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    // import Verify from "vue2-verify";
    import Vcode from "vue-puzzle-vcode";
    import {
        getRegistered,
        getSecurityCode,
        getSmscode,
        getNewcurrent,
        getRegisteredOr,
        existsUserName,
        editPassword
    } from "../../utils/interface";
    
    export default {
        components: {Vcode},
        data() {
            return {
                parkHeight: "",
                validCode: "",
                inputUsername: "",
                mobile: "",
                iphoneRepeatMess: "",
                iphoneRepeat: false,
                inputPassword: "",
                inputPasswordAg: "",
                passwordAgTrue: false,
                inputMessage: "",
                checked: false,
                validation: false,
                validationSuc: "",
                imgUrls: [
                    require("../../assets/images/111111.jpeg"),
                    require("../../assets/images/validation.png"),
                ],
                vcodes: false,
                canClick: true,
                timeClock: 60,
                dialogVisible: false,
                cryptographicMessage: '',
                cryptographicFlag: true
            };
        },
        created() {
            this.parkHeight = document.documentElement.clientHeight + "px";
            this.vuexAllPark(false);
        },
        watch: {},
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
            }),
        },
        mounted() {
            window.scrollTo(0, 0);
            if(this.mobile){
                this.getinputIphone()
            }
            this.cryptographic()
        },
        methods: {
            ...mapMutations(["vuexAllPark", "isLoginVuex"]),
            // 顶部跳转
            getRegisteredLogin(num) {
                if (num == 1) {
                    this.$router.push("/");
                }
            },
            getLogin() {
                this.$router.push("/loginIndex");
            },
            // 验证初始密码和再次输入密码是否一致
            passwordAgChange() {
                if (this.inputPassword != this.inputPasswordAg) {
                    this.passwordAgTrue = true;
                } else {
                    this.passwordAgTrue = false;
                }
            },
            getinputIphone() {
                if (this.mobile) {
                    //  校验是否注册过
                    let paramsOr = {
                        username: this.mobile,
                    };
                    existsUserName(paramsOr)
                        .then((res) => {
                            this.iphoneRepeat = res.success;
                            if (!this.iphoneRepeat) {
                                this.iphoneRepeatMess = '手机号未注册，请先注册';
                            } else {
                                this.iphoneRepeatMess = "";
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            },
            // 拼图验证码
            getValidation() {
                this.validation = true;
            },
            // 用户的验证回调
            onValidation(status, msg) {
                if (status == "yes") {
                    // this.vcodes = true;
                    
                    getSecurityCode()
                        .then((res) => {
                            console.log(res);
                            this.vcodes = true;
                            this.validCode = res.data;
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } else if (status == "no") {
                    this.vcodes = false;
                }
                this.validation = false; // 通过验证后，需要手动隐藏模态框
                //可以在此加上axios或其他代码
            },
            // 用户点击遮罩层，应该关闭模态框
            onClose() {
                this.validation = false;
                this.$message({
                    message: "取消验证！",
                    type: "warning",
                });
            },
            // 点击注册信息
            getRegisteredMess() {
                let params = {
                    mobile: this.mobile,
                    password: this.inputPassword,
                    validCode: this.validCode,
                    smsCode: this.inputMessage,
                };
                const reg = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
                if (
                    this.mobile == "" ||
                    !reg.test(this.mobile) ||
                    this.inputPassword == "" ||
                    this.inputPasswordAg == "" ||
                    this.inputMessage == "" ||
                    this.vcodes == false ||
                    this.passwordAgTrue == true ||
                    !this.iphoneRepeat||
                    !this.cryptographicFlag
                ) {
                  if (this.mobile == "") {
                        this.$alert("您的手机号码不能为空", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (!reg.test(this.mobile)) {
                        this.$alert("请输入正确的手机号码", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (this.inputPassword == "") {
                        this.$alert("您的密码不能为空", "提示", {
                            confirmButtonText: "确定",
                        });
                    }else if(!this.cryptographicFlag){
                      this.$alert("密码校验不通过，请重新输入密码", "提示", {
                          confirmButtonText: "确定",
                      });
                  } else if (this.inputPasswordAg == "") {
                        this.$alert("再次输入密码不能为空", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (this.passwordAgTrue == true) {
                        this.$alert("您输入的两次密码不相符，请重新输入", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (this.inputMessage == "") {
                        this.$alert("您的短信验证码不能为空", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (this.vcodes == false) {
                        this.$alert("请进行安全验证", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (!this.iphoneRepeat) {
                        this.$alert(this.iphoneRepeatMess, "提示", {
                            confirmButtonText: "确定",
                        });
                    }
                } else {
                    editPassword(params)
                        .then((res) => {
                            if (res.success == true) {
                                this.$alert("密码修改成功", "提示", {
                                    confirmButtonText: "确定",
                                    callback: () => {
                                        this.$router.push("/loginIndex");
                                    },
                                });
                            } else {
                                this.$alert(res.message, "提示", {
                                    confirmButtonText: "确定",
                                    callback: (action) => {
                                        this.inputMessage = "";
                                        this.vcodes = false;
                                        this.canClick = true;
                                    },
                                })
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            },
            // 倒计时60s
            getCountdown() {
                if (this.vcodes == true && this.iphoneRepeatMess == "" && this.cryptographicFlag) {
                    let params = {
                        mobile: this.mobile,
                        validCode: this.validCode,
                    };
                    getSmscode(params)
                        .then((res) => {
                            console.log("res", res);
                            if (res.success == true) {
                                this.canClick = false;
                                let clock = window.setInterval(() => {
                                    this.timeClock--;
                                    if (this.timeClock < 0) {
                                        //当倒计时小于0时清除定时器
                                        window.clearInterval(clock);
                                        this.canClick = true;
                                    }
                                }, 1000);
                            } else {
                                this.$alert(res.message, "提示", {
                                    confirmButtonText: "确定",
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } else {
                    if (this.vcodes == false) {
                        this.$alert("安全验证失败，请重新验证", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (this.iphoneRepeatMess != "") {
                        this.$alert("手机号未注册，请先注册", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if(!this.cryptographicFlag ){
                        this.$alert("密码校验不通过，请重新输入密码", "提示", {
                            confirmButtonText: "确定",
                        });
                    }
                }
            },
            // 协议
            getAgreement() {
                this.dialogVisible = true;
            },
            // 密码校验
            cryptographic(){
                if(this.inputPassword){
                    if(this.inputPassword.length < 8){
                        this.cryptographicMessage = '密码长度不小于8位'
                        this.cryptographicFlag = false
                    } else if(!this.validate.isUserPassword(this.inputPassword)) {
                        this.cryptographicMessage = '数字,字母,字符至少包含两种,不能包含中文和空格'
                        this.cryptographicFlag = false
                    } else if(this.inputPassword.length >= 30) {
                        this.cryptographicMessage = '密码长度不大于30位'
                        this.cryptographicFlag = false
                    } else {
                        this.cryptographicMessage = ''
                        this.cryptographicFlag = true
                    }
                } else {
                    this.cryptographicMessage = ''
                    this.cryptographicFlag = true
                }
            }
        },
    };
</script>

<style scoped lang="less">
    .blue {
        color: #1181ff;
    }
    
    .red {
        color: #d60000;
    }
    
    .registered {
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        border-radius: 10px;
        
        .registeredTop {
            border-bottom: 1px solid #f9f9f9;
            padding: 18px 30px 18px 44px;
            align-items: center;
            justify-content: space-between;
            // margin: 40px 0;
            display: flex;
            span {
                cursor: pointer;
            }
        }
        
        .registered_input_box {
            display: flex;
            justify-content: center;
            
            .registered_input {
                padding-bottom: 50px;
                width: 50%;
                padding-top: 30px;
                /deep/ .el-input {
                    // width: 50%;
                    // margin-bottom: 25px;
                }
                
                /deep/ .el-input__inner {
                    background: #f9f9f9;
                    color: #777;
                    border: none;
                    height: 52px;
                }
                
                .passAg {
                    align-items: center;
                    
                    p {
                        font-size: 14px;
                        margin-left: 10px;
                        margin-bottom: 25px;
                        flex-shrink: 0;
                    }
                }
                
                .registered_input_message {
                    position: relative;
                    
                    /deep/ .el-input {
                    }
                    
                    .registered_input_messageP {
                        position: absolute;
                        right: 30px;
                        top: 2px;
                        cursor: pointer;
                    }
                }
                
                .registered_message {
                    margin-top: 20px;
                    font-size: 14px;
                    cursor: default;
                    
                    span {
                        cursor: pointer;
                    }
                }
                
                .registered_validation2 {
                    background: #3aead336;
                    height: 52px;
                    margin-bottom: 25px;
                    align-items: center;
                    color: #777;
                    cursor: default;
                    justify-content: center;
                    color: #6dcaaa;
                    border: 1px solid #6dcaaa;
                    display: flex;
                    i {
                        font-size: 20px;
                        font-weight: bold;
                        margin-right: 10px;
                    }
                }
                
                .registered_validation {
                    background: #f9f9f9;
                    height: 52px;
                    margin-bottom: 25px;
                    align-items: center;
                    color: #777;
                    cursor: pointer;
                    display: flex;
                    img {
                        margin: 0 13px;
                    }
                    
                    .validationVerify {
                        z-index: 99;
                    }
                }
            }
            
            .registered_agree {
                margin-top: 10px;
            }
            
            .registered_button {
                width: 100%;
                margin-top: 40px;
                
                /deep/ .el-button {
                    width: 100%;
                }
            }
        }
    }
    
    .tittle {
        position: fixed;
        background: #fff;
        box-shadow: 0 -1px 0 #f0f0f0 inset;
        width: 100%;
        height: 80px;
        z-index: 9999;
        
        .titleTop {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        
        .logo {
            // margin: 19px 42px 0 38px;
            // align-items: center;
            // justify-content: center;
            // display: flex;
            // flex: 1;
            img {
                height: 50px;
                margin: 8px 0 0 0;
                padding: 0;
            }
        }
    }
    
    .login {
        // justify-content: center;
        // align-items: center;
        // flex: 1;
        .lh90 {
            cursor: pointer;
            font-size: 15px;
        }
        
        .lh90:nth-last-child(1) {
            margin-left: 60px;
        }
    }
    
    /deep/ .el-dialog {
        height: 600px;
        // max-height: 50%;
        // overflow: hidden;
    }
    
    /deep/ .el-dialog--center .el-dialog__body {
        overflow-y: scroll;
        height: 78%;
        // min-height: 54%;
        margin: 10px 20px;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/login/forgetPassword.vue